export default "__VITE_PUBLIC_ASSET__e7a3fe8c__"